import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {PreloadService} from "../../services/preloadService/preload.service";
import {animateShow} from "../../animations/showHideAnimation";

@Component({
  selector: 'app-page-preload',
  templateUrl: './page-preload.component.html',
  styleUrls: ['./page-preload.component.scss'],
  animations: [animateShow],
})
export class PagePreloadComponent implements OnInit {

  public isPreloading = false;
  public Yiit = Yiit;
  public modalMessage = Yiit.t('Generating Screenshot');

  constructor(private preloadService: PreloadService, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.preloadService.isPreloading$.subscribe((value:boolean)=>{
      this.isPreloading = value;
      console.log('this.isPreloading', this.isPreloading);
      this.cd.detectChanges();
    });

    this.preloadService.preloadMessage$.subscribe((value)=>{
      this.modalMessage = value;
    })
  }

}
